import { render, staticRenderFns } from "./DocumentCenterPage.vue?vue&type=template&id=8241bbf4"
import script from "./DocumentCenterPage.vue?vue&type=script&lang=js"
export * from "./DocumentCenterPage.vue?vue&type=script&lang=js"
import style0 from "./DocumentCenterPage.vue?vue&type=style&index=0&id=8241bbf4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports